import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";

export const getIsAncestorDragging = (
  parent: NodeApi<Node> | null,
): boolean => {
  if (!parent || parent.level < 0) {
    return false;
  }
  if (parent.isDragging) {
    return true;
  }
  return getIsAncestorDragging(parent.parent);
};
